import { getApiBaseUrl } from './getEnv';

/**
 * Absolute URL to the Google OAuth start endpoint on mops-api. `AuthProvider`
 * performs a full-page navigation here when the session check fails.
 */
export const getGoogleStartUrl = (): string => `${getApiBaseUrl()}/auth/google/start`;

/** Absolute URL to the mops-api logout endpoint (POST, returns JSON). */
export const getLogoutUrl = (): string => `${getApiBaseUrl()}/auth/logout`;
